import React, { useContext } from 'react';
import { OrderProvider } from './contexts/OrderContext';
import { AuthContext, AuthProvider } from './contexts/AuthContext';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import ProductsPage from './pages/ProductsPage';
import AboutPage from './pages/AboutPage';
import routes from './utils/routes';

function AuthRoute({ element, redirectTo }) {
  const { isLogged } = useContext(AuthContext);
  return isLogged ? <Navigate to={redirectTo} /> : element;
}

function NoAuthRoute({ element, redirectTo }) {
  const { isLogged } = useContext(AuthContext);
  return isLogged ? element : <Navigate to={redirectTo} />;
}

function App() {
  return (
    <AuthProvider>
      <OrderProvider>
        <Router>
          <Routes>
            <Route path={routes.home} index element={<HomePage />} />
            <Route
              path={routes.login}
              index
              element={<AuthRoute element={<LoginPage />} redirectTo={routes.home} />}
            />
            <Route
              path={routes.profile}
              index
              element={<NoAuthRoute element={<ProfilePage />} redirectTo={routes.home} />}
            />
            <Route path={routes.products} index element={<ProductsPage />} />
            <Route path={routes.about} index element={<AboutPage />} />
            <Route path="*" element={<Navigate to={routes.home} />} />
          </Routes>
        </Router>
      </OrderProvider>
    </AuthProvider>
  );
}

export default App;
